/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class GroupRoute extends Route {
  // Services
  @service
  store;

  setupController(controller, model) {
    super.setupController(controller, model);
    let appController = this.controllerFor('application');
    appController.setPeopleSelectorDefault(
      mapBy(model.currentLearners, 'person'),
    );
  }

  model(params) {
    return hash({
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        groupId: params.group_id,
        includeFormer: true,
      }),
      group: this.store.findRecord('group', params.group_id),
    }).then((data) => data.group); // Return just the group as the model.
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('application').setPeopleSelectorDefault([]);
  }
}
